import { render, staticRenderFns } from "./ListLink.vue?vue&type=template&id=4f8bc8c1&"
import script from "./ListLink.vue?vue&type=script&lang=js&"
export * from "./ListLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports